import { skipToken } from '@reduxjs/toolkit/query/react';
import { SearchFilterCondition } from 'lib-search-types';
import { useMemo } from 'react';

import {
  CustomFieldAttribute,
  CustomFieldEntity,
  customFieldsApi,
} from 'apis/customFields';
import { isCustomAttributeCondition } from 'app/views/layout/views/search/utils/filters/filterTypeGuards';

/**
 * A hook that checks whether a condition matches a custom attribute and returns
 * the custom attribute object from the API cache.
 */
export const useFilterConditionCustomAttribute = (
  condition: SearchFilterCondition<'conversations'>,
): CustomFieldAttribute | null => {
  const entityId = useMemo((): CustomFieldEntity | null => {
    switch (condition.field) {
      case 'conversation_custom_attribute':
        return 'conversation';
      case 'contact_custom_attribute':
        return 'contact';
      default:
        return null;
    }
  }, [condition]);

  const { customAttributes } =
    customFieldsApi.endpoints.readAttributes.useQueryState(
      entityId ? { entityId } : skipToken,
      {
        selectFromResult: ({ data, ...rest }) => ({
          ...rest,
          customAttributes: data?.data.attributes ?? [],
        }),
      },
    );

  return useMemo(
    () =>
      (isCustomAttributeCondition(condition) &&
        customAttributes.find(({ id }) => id === condition.attributeId)) ||
      null,
    [condition, customAttributes],
  );
};
